import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ShipmentService} from "../../../../../../../../common/services/shipment.service";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {Api} from "../../../../../../../../common/services/api.service";
import {Modal} from "../../../../../../../services/modal.service";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {Warehouse} from "../../../../../../../../common/interfaces/warehouse.interface";
import {Router} from "@angular/router";

@Component({
    selector: "section-shipment-join-modal",
    template: `
        <h1 class="container-heading">Join shipments</h1>
        <mat-card>
            <mat-card-content>
                <form>
                    <div class="group flex">
                        <div *ngFor="let s of modal.params.shipment.joined_shipments">
                            <mat-checkbox (change)="selectToJoin(s, $event)"
                                          [disabled]="isDisabled()"
                                          [checked]="isChecked(s)">
                                <b>Order:</b> {{ s.order.ref }}.
                                <b>Status: </b> {{ s.order.status?.name }}.
                                <b>Shipment:</b> {{ s.ref }}.
                            </mat-checkbox>
                        </div>
                    </div>

                    <div class="actions">
                        <button mat-raised-button color="primary"
                                [disabled]="isDisabled()"
                                type="button" class="main" (click)="submit()"
                                *ngIf="!modal.params.shipment.parent_id">
                            Update
                        </button>

                        <button mat-raised-button color="primary"
                                type="button" class="main" (click)="goToMainOrder()"
                                *ngIf="modal.params.shipment.parent_id">
                            Open main order
                        </button>

                        <button mat-button type="button" (click)="modal.response.emit(null)">
                            Close
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShipmentJoinModalComponent {

    private joins: { shipment_id: number, join: boolean }[] = [];

    public modal: Modal.IModal;


    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private spinnerService: SpinnerService,
        private api3Service: Api3Service,
        private toastService: ToastService,
        private router: Router
    ) {
    }

    public isChecked(shipment: Warehouse.IShipment): boolean {
        if (this.modal.params.shipment.parent_id) {
            return this.modal.params.shipment.parent_id === shipment.id
                || this.modal.params.shipment.parent_id === shipment.parent_id;
        } else {
            return this.modal.params.shipment.id === shipment.parent_id;
        }
    }

    public isDisabled(): boolean {
        if (this.modal.params.shipment.parent_id) {
            return true;
        } else if (![64, 65, 82, 92].includes(this.modal.params.shipment.warehouse_order.status_id)) {
            return true;
        }

        return false;
    }

    public goToMainOrder(): void {
        for (const shipment of this.modal.params.shipment.joined_shipments) {
            if (!shipment.parent_id) {
                this.router.navigate([
                    this.modal.params.state.section,
                    "orders",
                    "view",
                    "id",
                    shipment.order_id,
                ]);

                this.modal.response.emit({
                    name: "success",
                    value: true
                });
                break;
            }
        }
    }

    public selectToJoin(shipment: Warehouse.IShipment, event: any): void {

        this.joins = this.joins.filter(j => j.shipment_id !== shipment.id);

        this.joins.push({
            shipment_id: shipment.id,
            join: event.checked
        });
    }

    public async submit(): Promise<any> {
        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `/${this.modal.params.state.section}/shipments/${this.modal.params.shipment.id}/join`, {
                joins: this.joins,
            });

        this.spinnerService.hide();
        if (code === 200) {
            this.toastService.show(message, "success");


            this.modal.response.emit({
                name: "success",
                value: true
            });
        }
    }
}
